import { SendEmailFieldNames, useSendEmailForm } from 'hooks/forms';
import { useSendForgotPassword } from 'hooks/api/changePassword';
import Button from 'components/Button';
import Field from 'components/Field';
import messages from './ForgotPassword.messages';
import styles from './ForgotPassword.module.css';

export default function ForgotPassword() {
  const { mutateAsync: sendForgotPassword, isLoading } = useSendForgotPassword();
  const {
    form,
    customState: { isCompleted },
  } = useSendEmailForm();
  const { handleSubmit, getValues } = form;

  const onSubmit = () => {
    const { email } = getValues();
    sendForgotPassword({ email });
  };

  return (
    <div className={styles.forgotPassword}>
      <h1 className={styles.forgotPassword__title}>{messages.title}</h1>
      <p className={styles.forgotPassword__subtitle}>{messages.subtitle}</p>
      <form className={styles.forgotPassword__form} onSubmit={handleSubmit(onSubmit)}>
        <Field
          form={form}
          name={SendEmailFieldNames.email}
          placeholder={messages.placeholder.email}
          className={styles.forgotPassword__input}
          defaultValue={''}
          type={'email'}
          maxLength={256}
        />
      </form>
      <Button
        onClick={form.handleSubmit(onSubmit)}
        displayDisabledUI={!isCompleted}
        className={styles.forgotPassword__button}
        isLoading={isLoading}
      >
        {messages.buttonContinue}
      </Button>
    </div>
  );
}
